module.exports = __webpack_public_path__ + "img/3.0c8845a6.svg";